define('shoptheme/components/contentbridge/cms-search-results',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	Component,
	BEM,
	BreakPoints,
	enquire
) {
	return Component.create({

		blocks: null,

		$init: function() {

			this.textOverflowEllipsis();

			this.blocks = BEM.block('contentbridge-search-result__content');
			this.blocks.each(function() {

				var block = BEM.block(this),
					children = block.find('.wrapper');

				var childHeight = Math.max.apply(Math,children.map(function(){
					return $(this).outerHeight();
				}).get());

				enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
					match: function() {
						children.css('height', childHeight + 'px');
					},
					unmatch: function() {
						children.css('height', 'auto');
					}
				}, true);
				
			});

		},

		textOverflowEllipsis: function() {
			var ellipsisElements = $('.ellipsis-readmore');
			$.each(ellipsisElements, function(index, element){
				var elem = $(element),
					wrapper = elem.find('.ellipsis-readmore-wrapper'),
					readMoreLink = elem.find('a.read-more');

				wrapper.dotdotdot();
				$(window).resize($.throttle(10, function() { wrapper.dotdotdot(); }));
				readMoreLink.on('click', function(e){
					e.preventDefault();
					var content = wrapper.triggerHandler("originalContent");
					elem.html(content);
				});
				wrapper.trigger("isTruncated", function( isTruncated ) {
					if ( isTruncated ) {
						readMoreLink.show();
					}
				});
			});
		}

	});
});
